module.exports = require("core-js-pure/features/array/is-array");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/array/is-array.js
// module id = 2028
// module chunks = 25